import { redirect } from "@tanstack/react-router";
import { authClient } from "./auth-client";

export async function requireAuth() {
  const session = await authClient.getSession();
  if (!session.data) throw redirect({ to: "/login" });
  return session.data;
}

export async function requireAdmin() {
  const session = await requireAuth();
  if (session.user.role !== "admin") throw redirect({ to: "/dashboard" });
  return session;
}
